import { render, staticRenderFns } from "./LayerStack.vue?vue&type=template&id=39311362&scoped=true"
import script from "./LayerStack.vue?vue&type=script&lang=js"
export * from "./LayerStack.vue?vue&type=script&lang=js"
import style0 from "./LayerStack.vue?vue&type=style&index=0&id=39311362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39311362",
  null
  
)

export default component.exports